import { render, staticRenderFns } from "./WebMail.vue?vue&type=template&id=d5b4a1ee&"
import script from "./WebMail.vue?vue&type=script&lang=js&"
export * from "./WebMail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports